<template>
  <div>
    <list row-key="RecordId" ref="list" unit="首页板块" :expand-all-row="true" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="showQuery" :get-data-func="api.list">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="板块名称">
          <el-input v-model="params.SectionName" placeholder="请输入板块名称" clearable />
        </el-form-item>
        <el-form-item label="板块类型" label-width="85px">
          <el-select v-model="params.SectionType" placeholder="请选择板块类型" clearable>
            <el-option label="广告区域" :value="1"></el-option>
            <el-option label="商品区域" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="OrderId" label="排序" align="center" width="60" />
        <el-table-column prop="SectionName" label="板块名称" />
        <el-table-column prop="SectionType" label="板块类型">
          <template slot-scope="{row}">
            <span v-if="row.SectionType == 1">广告区域</span>
            <span v-else-if="row.SectionType == 2">商品区域</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作">
          <template slot-scope="{row}">
            <el-link type="primary" @click="showSectionad(row)">板块设置</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <sectionad-dialog ref="sectionadDialog" />
    <!-- <sectiongoods-dialog ref="sectiongoodsDialog" /> -->
    <sectiongoodsedit-dialog ref="sectiongoodseditDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import sectionadDialog from "./sectionadDialog"
//import sectiongoodsDialog from "./sectiongoodsDialog"
import sectiongoodseditDialog from "@/components/store/mallsectiongoods/editDialog.vue"

export default {
  mixins: [listMixin],
  components: {
    list,
    sectionadDialog,
    //  sectiongoodsDialog
    sectiongoodseditDialog
  },
  data() {
    return {
      api: require("@/api/mall/section").default,
      params: {
        SectionName: "",
        SectionType: null,
        State: null,
      },
    };
  },
  methods: {
    showSectionad(row) {
      if (row.SectionType == 1) {  //根据不同板块类别，打开不同界面，并且把行数据的recordid传入给打开界面的sectionid
        this.$refs.sectionadDialog.open().then(that => {

          that.getData({ SectionId: row.RecordId })
        })
      } else {
        // this.$refs.sectiongoodsDialog.open().then(that => {
        //  that.getData({ SectionId: row.RecordId })
        this.$refs.sectiongoodseditDialog.open().then(that => {
          that.getData({ SectionId: row.RecordId })
        })
      }

    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>